var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "table",
        {
          staticClass: "basic-table",
          staticStyle: { width: "100%", border: "1px solid #e7e7e7" }
        },
        [
          _c("thead", [
            _c(
              "tr",
              {
                staticStyle: {
                  "background-color": "#e7e7e7",
                  height: "40px",
                  "font-size": "12px",
                  "font-family": "PingFang SC",
                  "font-weight": "400",
                  color: "#9a9a9a"
                }
              },
              [
                _c(
                  "th",
                  {
                    staticStyle: { width: "50px", border: "1px solid #e7e7e7" }
                  },
                  [
                    _c("el-checkbox", {
                      on: {
                        change: function($event) {
                          return _vm.allSelected($event)
                        }
                      },
                      model: {
                        value: _vm.allSelectValue,
                        callback: function($$v) {
                          _vm.allSelectValue = $$v
                        },
                        expression: "allSelectValue"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("th", { staticStyle: { width: "50px" } }, [_vm._v("序号")]),
                _vm._v(" "),
                _vm._l(_vm.title, function(item, index) {
                  return _c("th", { key: index }, [_vm._v(_vm._s(item))])
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _vm.list.length > 0
            ? _c(
                "tbody",
                { staticStyle: { "text-align": "center" } },
                _vm._l(_vm.list, function(listItem, listIndex) {
                  return _c(
                    "tr",
                    {
                      key: listIndex,
                      staticStyle: {
                        "min-height": "40px",
                        border: "1px solid #e7e7e7"
                      }
                    },
                    [
                      _c(
                        "td",
                        {
                          staticClass: "tableBorderMy",
                          staticStyle: { width: "50px" }
                        },
                        [
                          _c("el-checkbox", {
                            attrs: { value: listItem.checked },
                            on: {
                              change: function($event) {
                                return _vm.allSelectedChange($event, listIndex)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", { staticClass: "tableBorderMy" }, [
                        _vm._v(_vm._s(listIndex + 1))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "tableBorderMy" }, [
                        _vm._v(_vm._s(listItem.nos))
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        _vm._l(listItem.detailList, function(
                          singleItem,
                          itemIndex
                        ) {
                          return _c(
                            "div",
                            {
                              key: itemIndex,
                              class: {
                                tableBorderMyBtn: !(
                                  listItem.detailList.length - 1 ==
                                  itemIndex
                                )
                              },
                              staticStyle: {
                                height: "43px",
                                "line-height": "43px",
                                "border-right": "1px solid #e7e7e7"
                              }
                            },
                            [
                              _c("el-checkbox", {
                                on: {
                                  change: function($event) {
                                    return _vm.itemSelect(
                                      $event,
                                      listIndex,
                                      itemIndex,
                                      singleItem.id
                                    )
                                  }
                                },
                                model: {
                                  value: singleItem.checked,
                                  callback: function($$v) {
                                    _vm.$set(singleItem, "checked", $$v)
                                  },
                                  expression: "singleItem.checked"
                                }
                              }),
                              _vm._v(
                                "\n            " +
                                  _vm._s(singleItem.feeName) +
                                  "\n            "
                              )
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        _vm._l(listItem.detailList, function(
                          singleItem,
                          itemIndex
                        ) {
                          return _c(
                            "div",
                            {
                              key: itemIndex,
                              class: {
                                tableBorderMyBtn: !(
                                  listItem.detailList.length - 1 ==
                                  itemIndex
                                )
                              },
                              staticStyle: {
                                height: "43px",
                                "line-height": "43px",
                                "border-right": "1px solid #e7e7e7"
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(singleItem.amount) +
                                  "\n          "
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        _vm._l(listItem.detailList, function(
                          singleItem,
                          itemIndex
                        ) {
                          return _c(
                            "div",
                            {
                              key: itemIndex,
                              class: {
                                tableBorderMyBtn: !(
                                  listItem.detailList.length - 1 ==
                                  itemIndex
                                )
                              },
                              staticStyle: {
                                height: "43px",
                                "line-height": "43px",
                                "border-right": "1px solid #e7e7e7"
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(singleItem.inputtime) +
                                  "\n          "
                              )
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        _vm._l(listItem.detailList, function(
                          singleItem,
                          itemIndex
                        ) {
                          return _c(
                            "div",
                            {
                              key: itemIndex,
                              class: {
                                tableBorderMyBtn: !(
                                  listItem.detailList.length - 1 ==
                                  itemIndex
                                )
                              },
                              staticStyle: {
                                height: "43px",
                                "line-height": "43px",
                                "border-right": "1px solid #e7e7e7"
                              }
                            },
                            [
                              singleItem.status == "1"
                                ? _c("span", [_vm._v("待支付")])
                                : _vm._e(),
                              _vm._v(" "),
                              singleItem.status == "2"
                                ? _c("span", [_vm._v("待审核")])
                                : _vm._e(),
                              _vm._v(" "),
                              singleItem.status == "3"
                                ? _c("span", [_vm._v("已完成")])
                                : _vm._e()
                            ]
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        _vm._l(listItem.detailList, function(
                          singleItem,
                          itemIndex
                        ) {
                          return _c(
                            "div",
                            {
                              key: itemIndex,
                              class: {
                                tableBorderMyBtn: !(
                                  listItem.detailList.length - 1 ==
                                  itemIndex
                                )
                              },
                              staticStyle: {
                                height: "43px",
                                "line-height": "43px"
                              }
                            },
                            [
                              singleItem.feeName
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "myCursor",
                                      on: { click: _vm.getDetail }
                                    },
                                    [_vm._v("费用详情")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "myCursor",
                                  staticStyle: {
                                    color: "#604aff",
                                    "margin-left": "10px"
                                  }
                                },
                                [_vm._v("支付")]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  )
                }),
                0
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.list.length == 0
        ? _c(
            "div",
            {
              staticStyle: {
                "line-height": "100px",
                height: "100px",
                width: "100%",
                color: "#999",
                "text-align": "center"
              }
            },
            [_vm._v("\n            暂无数据\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "费用详情",
            visible: _vm.dialogVisible,
            width: "30%",
            center: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%", "margin-top": "20px" },
                  attrs: {
                    data: _vm.detail,
                    "header-cell-style": {
                      background: "#eef1f6",
                      color: "#606266"
                    },
                    border: "",
                    align: "center",
                    "highlight-current-row": ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: { prop: "feeName", label: "费用类型", width: "180" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "name", label: "费用名称" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "amount", label: "价格" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "amount2", label: "费用详情" }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-80e80ccc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80e80ccc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PersonalCenter/billType/tabelTest.vue
// module id = null
// module chunks = 